<template>
  <div class="selectedDetails">
    <Left :detailsData="detailsData" />
    <Center :wenxian="wenxian" :type="type" :detailsData="detailsData.data" />
    <Right
      :autherList="autherList"
      :autherInfo="autherInfo"
      :type="type"
      :detailsData="detailsData"
      :periodicalInfo="periodicalInfo"
      :periodiID="periodiID"
    />
  </div>
</template>

<script>
import Left from "../components/left";
import Center from "./components/center";
import Right from "./components/right";
//articleType=0&&type=3论文详情  articleType=5&&type=0 资讯管理详情  articleType=5&7type=1征稿函详情 articleType=6万商数据详情  articleType=0&7type=3 文摘详情
//type 1 代表 论文详情 &&id
//type 2 代表 资讯管理详情 &&id
//type 3 代表 征稿函详情 &&id
//type 4      万商数据详情 &&id
//type 5      文摘详情 &&id
export default {
  name: "index",
  components: {
    Left,
    Center,
    Right,
  },
  created() {
    // this.GetDetailsData();
    // this.getwenxian()
  },
  data() {
    return {
      detailsData: {},
      autherInfo: {},
      type: null,
      wenxian: [],
      autherList: {},
      periodicalInfo: {},
      periodiID: {},
    };
  },
  watch: {
    $route: {
      handler() {
        this.GetDetailsData();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    async Getperiodical() {
      let obj = {
        type: this.detailsData.data.userType,
        // userId: this.detailsData.data.createUser,
        companyId: this.detailsData.data.periodicalId,
      };
      console.log(obj, "GetperiodicalObj");
      const res = await this.$apis.recomendServe.getAuthor(obj);
      this.periodicalInfo = res.content;
    },
    async getperiodiID() {
      let obj = {
        periodicalId: this.detailsData.data.periodicalId,
      };
      console.log(obj, "getperiodiIDObj");
      const res = await this.$apis.recomendServe.periodiID(obj);
      this.periodiID = res.data;
      console.log(res);
    },
    async getwenxian() {
      const { data } = await this.$apis.recomendServe.getwenxian({
        keyword: this.detailsData.data.keyword,
        pageNo: 1,
        pageSize: 5,
      });
      try {
        this.wenxian = data.list;
      } catch (e) {
        console.log(e);
      }
    },

    async getAuthor() {
      let userobj = {
        type: this.detailsData.data.userType,
      };
      if (this.detailsData.data.userType == 0) {
        userobj["userId"] = this.detailsData.data.createUser;
      } else {
        userobj["companyId"] = this.detailsData.data.companyId;
      }
      const res = await this.$apis.recomendServe.getAuthor(userobj);
      console.log(res);
      this.autherInfo = res.content;
      let othorAuthorInfo = [];
      console.log(this.detailsData.data);
      this.detailsData.data.articleAuthorList.forEach((item) => {
        othorAuthorInfo.push(item.authorId);
      });
      let aurtherObj = {
        communicationAuthorInfo: this.detailsData.data.communicationAuthorId,
        firstAuthorInfo: this.detailsData.data.firstAuthorId,
        othorAuthorInfo,
      };
      console.log(aurtherObj, "aurtherObj");
      const result = await this.$apis.recomendServe.getAuthorList(aurtherObj);
      console.log(aurtherObj);
      this.autherList = result.data.othorAuthorInfo;
      this.autherList.unshift(result.data.firstAuthorInfo);
      this.autherList.push(result.data.communicationAuthorInfo);
    },
    async getTable() {
      let res = await this.$apis.recomendServe.getTable();
      sessionStorage.setItem("Table", JSON.stringify(res));
    },
    async GetDetailsData() {
      let arr = {};
      if (sessionStorage.getItem("Table")) {
        arr = JSON.parse(sessionStorage.getItem("Table")).PlatformEnum;
      } else {
        await this.getTable();
        arr = JSON.parse(sessionStorage.getItem("Table")).PlatformEnum;
      }

      let PlatformEnumObj = {};
      arr.forEach((item) => {
        if (item.name === "中文知识网") {
          PlatformEnumObj = item;
        }
      });
      this.type = this.$router.history.current.query.type;
      const obj = {
        articleId: this.$router.history.current.query.id,
        articleType: this.$router.history.current.query.type,
        projectId: PlatformEnumObj.id,
      };
      const { data } = await this.$apis.recomendServe.getDetails(obj);
      this.detailsData = data;
      document.title = this.$global.matchReg(this.detailsData.title)

      await this.getwenxian();
      await this.getAuthor();
      // await this.getPublisherInfo();
      await this.Getperiodical();
      await this.getperiodiID();
    },
  },
};
</script>

<style lang="scss" scoped>
.selectedDetails {
  width: 1300px;
  display: flex;
  //justify-content: space-between;
}
</style>
